const RequiredSvgIcon = (props: any) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={42} height={42} {...props}>
		<defs>
			<filter id='a' width={42} height={42} x={0} y={0} filterUnits='userSpaceOnUse'>
				<feOffset dy={3} />
				<feGaussianBlur result='blur' stdDeviation={3} />
				<feFlood floodOpacity={0.161} />
				<feComposite in2='blur' operator='in' />
				<feComposite in='SourceGraphic' />
			</filter>
		</defs>
		<g data-name='Grupo 18632'>
			<g filter='url(#a)' transform='translate(-.002)'>
				<circle
					cx={12}
					cy={12}
					r={12}
					fill='#fb2782'
					data-name='Elipse 1511'
					transform='translate(9 6)'
				/>
			</g>
			<path
				fill='#fff'
				d='M26.166 16.943A15.1 15.1 0 0 1 23.233 18a15.134 15.134 0 0 1 2.934 1.057 1.668 1.668 0 0 1-1.668 2.888 15.077 15.077 0 0 1-2.382-2.015 15.078 15.078 0 0 1 .551 3.071 1.668 1.668 0 1 1-3.335 0 15.035 15.035 0 0 1 .556-3.071 15.077 15.077 0 0 1-2.383 2.014 1.668 1.668 0 0 1-1.672-2.887A15.091 15.091 0 0 1 18.768 18a15.091 15.091 0 0 1-2.934-1.057 1.668 1.668 0 0 1 1.668-2.888 15.077 15.077 0 0 1 2.387 2.013 15.035 15.035 0 0 1-.552-3.071 1.668 1.668 0 0 1 3.335 0 15.035 15.035 0 0 1-.552 3.071 15.115 15.115 0 0 1 2.379-2.013 1.668 1.668 0 0 1 1.668 2.888Z'
				data-name='Trazado 74119'
			/>
		</g>
	</svg>
)
export default RequiredSvgIcon
